import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_TREASURIES_BY_YEAR = '[TREASURY] GET TREASURIES BY YEAR'
export const GET_TREASURY_OPENINGS = '[TREASURY] GET BRANCH TREASURY OPENINGS'
export const SAVE_TREASURY_OPENING = '[TREASURY] SAVE TREASURY OPENING'
export const SAVE_TREASURY_CLOSING = '[TREASURY] SAVE TREASURY CLOSING'
export const UNDO_TREASURY_CLOSING = '[TREASURY] UNDO TREASURY CLOSING'
export const VOID_TREASURY = '[TREASURY] VOID TREASURY OPENING'
export const GET_CASH_REGISTERS_BY_TREASURY = '[TREASURY] GET CASH REGISTERS BY TREASURY'
export const GET_MOVEMENTS_BY_TREASURY = '[TREASURY] GET MOVEMENTS BY TREASURY'
export const GET_DETAILED_AMOUNTS_BY_TREASURY = '[TREASURY] GET DETAILED AMOUNTS BY TREASURY'

export function getTreasuriesByYearAction(year) {
  const request = api.get(`/treasuries/by-year/${year}`)
  return (dispatch) => {
    dispatch({ type: GET_TREASURIES_BY_YEAR, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_TREASURIES_BY_YEAR, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_TREASURIES_BY_YEAR, error)
    }).finally(() => {
      dispatch({ type: GET_TREASURIES_BY_YEAR, payload: { loading: false } })
    })
  }
}

export function getTreasuryOpeningsAction() {
  const request = api.get('/treasuries/openings')
  return (dispatch) => {
    dispatch({ type: GET_TREASURY_OPENINGS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_TREASURY_OPENINGS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_TREASURY_OPENINGS, error)
    }).finally(() => {
      dispatch({ type: GET_TREASURY_OPENINGS, payload: { loading: false } })
    })
  }
}

export function saveTreasuryOpeningAction(data) {
  const request = api.post('/treasuries/save-opening', data)
  return (dispatch) => {
    dispatch({ type: SAVE_TREASURY_OPENING, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TREASURY_OPENING, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_TREASURY_OPENING, error)
    }).finally(() => {
      dispatch({ type: SAVE_TREASURY_OPENING, payload: { saving: false } })
    })
  }
}

export function saveTreasuryClosingAction(data) {
  const request = api.post('/treasuries/save-closing', data)
  return (dispatch) => {
    dispatch({ type: SAVE_TREASURY_CLOSING, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TREASURY_CLOSING, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_TREASURY_CLOSING, error)
    }).finally(() => {
      dispatch({ type: SAVE_TREASURY_CLOSING, payload: { saving: false } })
    })
  }
}

export function undoTreasuryClosingAction(treasuryId) {
  const request = api.put(`/treasuries/${treasuryId}/undo-closing`)
  return (dispatch) => {
    dispatch({ type: UNDO_TREASURY_CLOSING, payload: { undoing_id: treasuryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UNDO_TREASURY_CLOSING, payload: { undone_id: treasuryId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(UNDO_TREASURY_CLOSING, error)
    }).finally(() => {
      dispatch({ type: UNDO_TREASURY_CLOSING, payload: { undoing_id: treasuryId } })
    })
  }
}


export function voidTreasuryAction(treasuryId) {
  const request = api.put(`/treasuries/${treasuryId}/void`)
  return (dispatch) => {
    dispatch({ type: VOID_TREASURY, payload: { voiding_id: treasuryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_TREASURY, payload: { voided_id: treasuryId } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_TREASURY, error)
    }).finally(() => {
      dispatch({ type: VOID_TREASURY, payload: { voiding_id: treasuryId } })
    })
  }
}

export function getCashRegistersByTreasuryAction(treasuryId) {
  const request = api.get(`/treasuries/${treasuryId}/cash-registers`)
  return (dispatch) => {
    dispatch({ type: GET_CASH_REGISTERS_BY_TREASURY, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_CASH_REGISTERS_BY_TREASURY, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_CASH_REGISTERS_BY_TREASURY, error)
    }).finally(() => {
      dispatch({ type: GET_CASH_REGISTERS_BY_TREASURY, payload: { loading: false } })
    })
  }
}

export function getMovementsByTreasuryAction(treasuryId) {
  const request = api.get(`/treasuries/${treasuryId}/movements`)
  return (dispatch) => {
    dispatch({ type: GET_MOVEMENTS_BY_TREASURY, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_MOVEMENTS_BY_TREASURY, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_MOVEMENTS_BY_TREASURY, error)
    }).finally(() => {
      dispatch({ type: GET_MOVEMENTS_BY_TREASURY, payload: { loading: false } })
    })
  }
}

export function getTreasuryTotalsAction(treasuryId) {
  const request = api.get(`/treasuries/${treasuryId}/totals`)
  return (dispatch) => {
    dispatch({ type: GET_DETAILED_AMOUNTS_BY_TREASURY, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_DETAILED_AMOUNTS_BY_TREASURY, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_DETAILED_AMOUNTS_BY_TREASURY, error)
    }).finally(() => {
      dispatch({ type: GET_DETAILED_AMOUNTS_BY_TREASURY, payload: { loading: false } })
    })
  }
}